export default () => (
	<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M4 2.3A1.7 1.7 0 0 0 2.3 4v4A1.7 1.7 0 0 0 4 9.7h4A1.7 1.7 0 0 0 9.7 8V4A1.7 1.7 0 0 0 8 2.3H4zM3.7 4a.3.3 0 0 1 .3-.3h4a.3.3 0 0 1 .3.3v2.046A1 1 0 0 0 8 6H4a1 1 0 0 0-.3.046V4z"
			fill="#A87511"
		/>
	</svg>
);
